import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
    {
        path: "/",
        redirect: "/login",
    },
    // 登录
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/RegisterManage/LoginView.vue'),
        meta: {
            showSideMenu: false,
            showHeaderMenu: false,
        }
    },
    // 数据大屏-管理员
    {
        path: '/dataScreen',
        name: 'dataScreen',
        component: () => import('@/views/ScreenManage/DataScreenView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 数据大屏-普通用户
    {
        path: '/userScreen',
        name: 'userScreen',
        component: () => import('@/views/ScreenManage/UserScreenView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 商机管理
    {
        path: '/business',
        name: 'business',
        component: () => import('@/views/BusinessManage/BusinessView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    //商机管理-普通用户
    {
        path: '/userBusiness',
        name: 'userBusiness',
        component: () => import('@/views/BusinessManage/UserBusinessView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 商机详情
    {
        path: '/businessDetail/:id',
        name: 'businessDetail',
        component: () => import('@/views/BusinessManage/BusninessDetailView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 用户商机详情
    {
        path: '/userBusinessDetail/:id',
        name: 'userBusinessDetail',
        component: () => import('@/views/BusinessManage/UserBusinessDetailView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 渠道管理
    {
        path: '/channel',
        name: 'channel',
        component: () => import('@/views/ChannelManage/ChannelView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 商机审核
    {
        path: '/checkList',
        name: 'checkList',
        component: () => import('@/views/ApproveManage/CheckListView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 商机审核-普通用户
    {
        path: '/userCheckList',
        name: 'userCheckList',
        component: () => import('@/views/ApproveManage/userCheckListView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 入驻审核
    {
        path: '/enterList',
        name: 'enterList',
        component: () => import('@/views/ApproveManage/EnterListView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 报表管理
    {
        path: '/report',
        name: 'report',
        component: () => import('@/views/ReportView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 系统设置-参数配置
    {
        path: '/params',
        name: 'params',
        component: () => import('@/views/SettingManage/ParamsView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 系统设置-用户管理
    {
        path: '/user',
        name: 'user',
        component: () => import('@/views/SettingManage/UserView.vue'),
        meta: {
            showSideMenu: true,
            showHeaderMenu: true,
        }
    },
    // 系统设置-用户中心
    {
        path: '/userCenter',
        name: 'userCenter',
        component: () => import('@/views/SettingManage/UserCenterView.vue'),
        meta: {
            showSideMenu: false,
            showHeaderMenu: true,
        }
    },
    // 注册管理
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/RegisterManage/RegisterView.vue'),
        meta: {
            showSideMenu: false,
            showHeaderMenu: false,
        }
    },
    // 注册管理-重置注册
    {
        path: '/resetRegister',
        name: 'resetRegister',
        component: () => import('@/views/RegisterManage/resetRegisterView.vue'),
        meta: {
            showSideMenu: false,
            showHeaderMenu: true,
        }
    },
    // 注册管理-状态查询
    {
        path: '/registerStatus',
        name: 'registerStatus',
        component: () => import('@/views/RegisterManage/StatusView.vue'),
        meta: {
            showSideMenu: false,
            showHeaderMenu: true,
        }
    },
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

// 路由守卫，实现权限控制
router.beforeEach((to, from, next) => {
    // 获取用户权限信息
    const isAdmin = localStorage.getItem('isAdmin');//是否管理员
    const type = localStorage.getItem('type');//用户类型
    const token = localStorage.getItem('token');
    
    // 无需登录即可访问的路由
    const publicRoutes = ['login', 'register'];
    
    // 需要管理员权限的路由
    const adminRoutes = ['dataScreen', 'channel', 'checkList', 'enterList', 'report', 'params', 'user'];

    // 需要技术服务权限的路由
    const techRoutes = ['business', 'businessDetail'];
    
    // 需要普通用户权限的路由
    const userRoutes = ['userScreen', 'userBusiness', 'userBusinessDetail', 'userCheckList', 'userCenter', 'resetRegister', 'registerStatus'];
    
    // 如果存在token，不能访问登录或注册界面，根据身份重定向到对应首页
    if (window.location.href.includes("t=")) {
        next();
    } else { 
        if (token && publicRoutes.includes(to.name)) {
            if (isAdmin === 'true' && type === '1') {
                next({ name: 'dataScreen' });
            } else if (type === '1') {
                next({ name: 'business' });
            } else {
                next({ name: 'userScreen' });
            }
            return;
        }
    }
    
    // 如果是公共路由，直接放行
    if (publicRoutes.includes(to.name)) {
        next();
        return;
    }
    
    // 如果没有token，重定向到登录页
    if (!token) {
        next({ name: 'login' });
        return;
    }
    
    // 普通用户权限验证（优先检查，防止管理员/技服访问）
    if (userRoutes.includes(to.name)) {
        if (type !== '1') {
            next();
        } else {
            if (isAdmin === 'true') {
                next({ name: 'dataScreen' });
            } else {
                next({ name: 'business' });
            }
        }
        return;
    }
    
    // 技术服务权限验证
    if (techRoutes.includes(to.name)) {
        if (type === '1') {
            next();
        } else {
            next({ name: 'userScreen' });
        }
        return;
    }
    
    // 管理员权限验证
    if (adminRoutes.includes(to.name)) {
        if (isAdmin === 'true' && type === '1') {
            next();
        } else {
            if (type === '1') {
                next({ name: 'business' });
            } else {
                next({ name: 'userScreen' });
            }
        }
        return;
    }
    
    // 默认情况重定向到登录页
    next({ name: 'login' });
});

export default router
